import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import BaseTable from '../../../../components/BaseTable/BaseTable.component';
import { commaFormatted } from '../../../../utils/transformer.util';
import ContentTable from '../../../../components/ContentTable/ContentTable.component';
import { FINANCE_REALIZATION_TABLE_FIELDS } from '../../../../constants/finance/budgeting/realization.constant';

export default function Realization(props) {
  const { handleGetRealization, user } = props;
  const { school_unit } = user;
  const columns = [{
    name: 'Kode Akun',
    selector: 'code_of_account',
    sortable: true,
  }, {
    name: 'Deskripsi',
    selector: 'desc',
  }, school_unit.id > 9 ? ({
    name: 'RAPBY',
    selector: 'total',
    width: '200px',
    right: true,
    sortable: true,
    cell: row => commaFormatted(row.total),
  }) : ({
    name: 'RAPBS',
    selector: 'total',
    width: '200px',
    right: true,
    sortable: true,
    cell: row => commaFormatted(row.total),
  }), {
    name: 'Realisasi',
    selector: 'utilized_budget',
    sortable: true,
    right: true,
    cell: row => commaFormatted(row.utilized_budget),
  }, {
    name: 'Persentase',
    selector: 'percentage',
    sortable: true,
    right: true,
    cell: row => `${commaFormatted(row.percentage)}%`,
  }, {
    name: 'Sisa Anggaran',
    selector: 'remains',
    sortable: true,
    right: true,
    cell: row => commaFormatted(row.remains),
  }];

  const filters = {
    periode: {
      type: 'select',
      data: [
        { value: 0, label: 'Januari' },
        { value: 1, label: 'Februari' },
        { value: 2, label: 'Maret' },
        { value: 3, label: 'April' },
        { value: 4, label: 'Mei' },
      ],
    },
  };

  return (
    <BaseTable
      columns={columns}
      handleGet={handleGetRealization}
      filters={filters}
      title="Realisasi"
    />
  );
}

Realization.propTypes = {
  handleGetRealization: PropTypes.func,
  user: PropTypes.array,
};
Realization.defaultProps = {
  handleGetRealization: noop,
  user: [],
};
